/**
 * Email Gate - Handles access control and cookie management for premium shop collection
 * Works with Shopify's native newsletter form
 */

class EmailGate {
  constructor() {
    this.form = document.getElementById('EmailGateForm');
    this.cookieName = 'shop_access_email';
    this.cookieDays = 365; // Cookie expires in 1 year
    
    if (this.form) {
      this.init();
    }
    
    // Check access on page load for collection pages
    this.checkAccessOnLoad();
  }

  init() {
    // Check if form was successfully submitted (page reload after success)
    const successMessage = this.form.querySelector('.newsletter-form__message--success');
    if (successMessage) {
      // Form was submitted successfully, reload to show products
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      return;
    }

    // Intercept form submission to handle it with AJAX
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const emailInput = this.form.querySelector('input[type="email"]');
      const submitButton = this.form.querySelector('button[type="submit"]');
      const email = emailInput ? emailInput.value.trim() : '';
      
      if (!email) return;

      // Disable button during submission
      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        // Submit to Shopify
        const formData = new FormData(this.form);
        const response = await fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
          }
        });

        // Store email in cookie regardless of response
        this.setCookie(this.cookieName, email, this.cookieDays);

        // Show success message
        this.showSuccessMessage();

        // Reload page after delay to show products
        setTimeout(() => {
          window.location.reload();
        }, 1500);

      } catch (error) {
        console.error('Form submission error:', error);
        
        // Still grant access even if submission failed
        this.setCookie(this.cookieName, email, this.cookieDays);
        this.showSuccessMessage();
        
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    });
  }

  showSuccessMessage() {
    const fieldWrapper = this.form.querySelector('.newsletter-form__field-wrapper');
    if (fieldWrapper) {
      // Create success message
      const successDiv = document.createElement('h3');
      successDiv.className = 'newsletter-form__message newsletter-form__message--success form__message';
      successDiv.innerHTML = `
        <span class="svg-wrapper">
          <svg viewBox="0 0 13 13" class="icon icon-success" aria-hidden="true" focusable="false">
            <path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"></path>
            <path d="M5.53271 8.66357L9.25213 4.68197" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M3.59863 6.68203L5.53288 8.66362" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>
        ${this.form.closest('.email-gate-section').querySelector('[data-success-message]')?.dataset.successMessage || 'Thank you! Access granted. Refreshing page...'}
      `;
      fieldWrapper.parentNode.insertBefore(successDiv, fieldWrapper.nextSibling);
      fieldWrapper.style.display = 'none';
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  checkAccessOnLoad() {
    // This function checks if user has access via cookie
    // Used by the template to show/hide content
    const hasEmailAccess = this.getCookie(this.cookieName) !== null;
    
    // Store in sessionStorage for quick access by Liquid
    if (hasEmailAccess) {
      sessionStorage.setItem('shop_has_access', 'true');
    }
    
    return hasEmailAccess;
  }

  // Public method to check if user has access
  static hasAccess() {
    const emailGate = new EmailGate();
    return emailGate.checkAccessOnLoad();
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new EmailGate();
  });
} else {
  new EmailGate();
}

// Make available globally for template checks
window.EmailGate = EmailGate;
